<template>
  <action-modal-wizard
    ref="modal"
    title="Draw Request"
    modalIdPrefix="draw-"
    :loan="loan"
    @form-completed="submit"
    @modal-hidden="onModalHidden"
  >
    <tab-content :title="`Draw #${drawNumber}`" :before-change="validateDraw">
      <loading-component
        :url="`/users/${this.user.id}/loans/${this.loan._id}/get_draws_balance`"
        ref="loadingComponent"
        :autoRequest="false"
        errorMessage="Unable to load Draw Request data"
        @success="setBalance"
      >
        <estimate-of-repairs
          ref="estimateOfRepairs"
          :isDraw="true"
        />
      </loading-component>
    </tab-content>

    <tab-content title="Required Information" :before-change="validatePayment">
      <payment-form ref="paymentForm" :loan="loan" payment-method-type="Draw"/>
    </tab-content>

    <tab-content title="Additional Files">
      <additional-files-form
        ref="additionalForm"
        headline="
          If you have any additional files that you would like to
          submit with this request, please use the box below to do so.
        "
      />
    </tab-content>
  </action-modal-wizard>
</template>

<script>
import helper from '@/libs/helper';

import { TabContent } from 'vue-form-wizard';
import ActionModalWizard from '@/components/my_deals/actions/ActionModalWizard';
import EstimateOfRepairs from '@/components/my_deals/actions/estimate_of_repairs/EstimateOfRepairs';
import PaymentForm from '@/components/payments/create/PaymentForm';
import AdditionalFilesForm from '@/components/my_deals/actions/AdditionalFilesForm';
import LoadingComponent from '@/components/utils/LoadingComponent';


export default {
  components: {
    ActionModalWizard,
    TabContent,
    EstimateOfRepairs,
    PaymentForm,
    AdditionalFilesForm,
    LoadingComponent,
  },
  data() {
    return {
      balance: null,
    };
  },
  props: {
    loan: {
      type: Object,
      required: true,
    },
  },
  computed: {
    drawNumber() {
      return this.loan.draw_requests.length + 1;
    },
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    show() {
      this.balance = null;
      this.$refs.modal.show();
      this.$refs.loadingComponent.request();
    },
    hide() {
      this.$refs.modal.hide();
      this.balance = null;
    },
    validateDraw() {
      return this.$refs.estimateOfRepairs.validate();
    },
    validatePayment() {
      return this.$refs.paymentForm.validate();
    },
    onModalHidden() {
      this.$refs.estimateOfRepairs.reset();
      this.$refs.paymentForm.reset();
      this.$refs.additionalForm.reset();
    },
    submit() {
      const data = [];
      const expenses = helper.copy(this.$refs.estimateOfRepairs.model);
      const payment = helper.copy(this.$refs.paymentForm.model);
      Object.keys(expenses).forEach((key) => {
        delete expenses[key].balance;
      });

      data.payment = payment.paymentMethod;
      data.expenses = expenses;
      this.$refs.additionalForm.model.files.forEach(file => data.push(file));

      /* eslint no-underscore-dangle:  ["error", { "allow": ["_id"] }] */
      this.$reqs.uploadAssetManagement(`/users/${this.$store.getters.user.id}/loans/${this.loan._id}/draw`, data)
        .then((response) => {
          this.$notify({ group: 'alert', text: 'Draw Request saved successfully.' });
          this.$emit('draw-sent', response);
          this.$emit('new-total-balance', this.getTotalBalance());
          this.hide();
        })
        .catch(() => {});
    },
    setBalance(value) {
      this.balance = value;
      this.$nextTick(() => {
        this.$refs.estimateOfRepairs.setBalance(value);
      });
    },
    getTotalBalance() {
      const expenses = this.$refs.estimateOfRepairs.model;
      let totalExpensesSet = 0;
      Object.keys(expenses).filter(eKey => eKey !== 'description')
        .forEach((key) => {
          totalExpensesSet += Object.keys(expenses[key])
            .filter(fKey => fKey !== 'balance')
            .reduce((acc, currKey) => acc + parseFloat(expenses[key][currKey]), 0.0);
        });
      let totalBalance = 0;
      Object.keys(expenses).forEach((key) => {
        if (expenses[key].balance > 0) {
          totalBalance += expenses[key].balance;
        }
      });
      return totalBalance - totalExpensesSet;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/my_deals/actions/draw/DrawWizardModal.vue